import axios from "../axios";
import config from "@/utils/global.js";
// 获取公众号列表
export const wxMpViewQuery = (data) => {
  return axios({
    url: config.zuul + '/hhy-im/r/wxMpView/query',
    method: 'post',
    data: data
  })
}
// 获取菜单
export const getSelfMenuInfo = (data = { appid: '' }) => {
  return axios({
    url: config.zuul + `/hhy-im/r/wx/menu/${data.appid}/getSelfMenuInfo`,
    method: 'GET',
  })
}
// 获取菜单新
export const getMenus = (data = {
  appId: '',
}) => {
  return axios({
    url: config.zuul + '/hhy-im/r/wxMpMenu/getMenus',
    method: 'GET',
    params: data
  })
}

// 保存菜单
export const menuCreate = (data = {
  appid: '',
  menu: { buttons: [] },
}) => {
  return axios({
    url: config.zuul + `/hhy-im/w/wx/menu/${data.appid}/menuCreate`,
    method: 'post',
    data: data.menu
  })
}

//保存菜单
export const createMenu = (data) => {
  return axios({
    url: config.zuul + '/hhy-im/w/wxMpMenu/createMenu',
    method: 'POST',
    data: data.menus,
    params: {
      appId: data.appId
    },
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    }
  })
}

// 获取图片视频音频素材
export const getImgMaterial = (data = {
  appid: '',
  count: 10,
  offset: 0,
  type: 'image'
}) => {
  return axios({
    url: config.zuul + `/hhy-im/r/wx/material/getImgMaterial`,
    method: 'post',
    params: data
  })
}

// 图文素材
export const getPublicationRecords = (data = {
  appid: '',
  count: 10,
  noContent: 0,
  offset: 0,
}) => {
  return axios({
    url: config.zuul + `/hhy-im/r/wx/publish/getPublicationRecords`,
    method: 'POST',
    params: { ...data, noContent: 0 }
  })
}

// 上传文件
export const uploadFile = (data) => {
  return axios({
    url: config.zuul + `/hhy-im/w/wx/material/uploadFile`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundarytp3j8OramPyjbtRC"
    },
    data: data
  })
}

// 模版信息
export const getWxMpTemplate = (data = { appId: '' }) => {
  return axios({
    url: config.zuul + '/hhy-im/r/wxMpTemplate/getWxMpTemplate',
    method: "GET",
    params: data
  })
}

// 模版更新
export const wxMpTemplateSave = (data = {}) => {
  return axios({
    url: config.zuul + '/hhy-im/w/wxMpTemplate/save',
    method: 'POST',
    data: data
  })
}
// 模版删除
export const wxMpTemplateDelete = (data = []) => {
  return axios({
    url: config.zuul + '/hhy-im/w/wxMpTemplate/delete',
    method: 'POST',
    data: data
  })
}





// WEBPACK FOOTER //
// ./src/http/moudules/wxMenu.js